import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=071c0c79&scoped=true&"
import script from "./ActionCard.vue?vue&type=script&lang=js&"
export * from "./ActionCard.vue?vue&type=script&lang=js&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ActionCard.vue?vue&type=style&index=1&id=071c0c79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c0c79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071c0c79')) {
      api.createRecord('071c0c79', component.options)
    } else {
      api.reload('071c0c79', component.options)
    }
    module.hot.accept("./ActionCard.vue?vue&type=template&id=071c0c79&scoped=true&", function () {
      api.rerender('071c0c79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/ActionCard.vue"
export default component.exports